module.exports = __webpack_public_path__ + "assets/img/pjs_3.77bbef5b.png";